 'use client';

import { styled } from 'styled-components';
// import './styles.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  gradientDegree?: string;
}

const Component = ({ children, className }: Props): JSX.Element => {
  return (
    <div className={`rounded-lg shadow-md print:shadow-none ${className}`}>
      {children}
    </div>
  );
}
export default styled(Component)<Props>(props => ({
  backgroundImage: `linear-gradient(${props.gradientDegree || '45'}deg, var(--gradient-card-start-color), var(--gradient-card-end-color))`,
}));
